import styles from "./tournament-stats.module.css";

export default function TournamentStats() {
  const stats = [
    {
      icon: "🏆",
      label: "Total Prize Pool",
      value: "₹10+ Crores",
      description: "Distributed across all tournaments",
    },
    {
      icon: "👥",
      label: "Active Players",
      value: "50,000+",
      description: "From across India",
    },
    {
      icon: "🎮",
      label: "Supported Games",
      value: "15+",
      description: "Mobile, PC, and Console",
    },
    {
      icon: "⚡",
      label: "Tournaments Monthly",
      value: "200+",
      description: "New tournaments every week",
    },
  ];

  return (
    <section className={styles.statsSection}>
      <div className={styles.statsContainer}>
        {stats.map((stat, index) => (
          <div key={index} className={styles.statCard}>
            <div className={styles.statIcon}>{stat.icon}</div>
            <h3 className={styles.statValue}>{stat.value}</h3>
            <p className={styles.statLabel}>{stat.label}</p>
            <p className={styles.statDescription}>{stat.description}</p>
          </div>
        ))}
      </div>

      <div className={styles.ctaSection}>
        <h2 className={styles.ctaTitle}>Ready to Compete?</h2>
        <p className={styles.ctaText}>
          Join Pixel Moon's esports ecosystem and start your journey to becoming
          a champion
        </p>
        <button
          type="button"
          className={styles.ctaButton}
          onClick={() => (window.location.href = "https://wa.link/oskfd2")}
        >
          Get Started Now
          <span className={styles.ctaArrow}>→</span>
        </button>
      </div>
    </section>
  );
}
